export interface Color {
  r: number;
  g: number;
  b: number;
  a?: number;
}

// Anything toColor() accepts: a parsed Color, a CSS/hex string, or nullish
// (church color fields are nullable strings). Use this for component props that
// forward a color straight into toColor().
export type ColorInput = Color | string | null | undefined;

export function hexToRgb(hex: string): Color {
  if (hex.length === 4) hex = hex + hex.slice(1);
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return result
    ? {
        a: 1,
        b: parseInt(result[3], 16),
        g: parseInt(result[2], 16),
        r: parseInt(result[1], 16),
      }
    : { a: 1, b: 0, g: 0, r: 0 };
}
const toColor = (color: ColorInput, alpha = 1): string => {
  if (typeof color === 'string') {
    if (color.startsWith('rgb')) {
      const values = color.replace(/rgba?\((.+)\)/, '$1');
      const [r, g, b] = values.split(',');

      color = { b: parseInt(b), g: parseInt(g), r: parseInt(r) };
    } else if (color.startsWith('#')) {
      color = hexToRgb(color);
    } else {
      color = JSON.parse(color) as Color;
    }
  }

  return color ? `rgba(${color.r}, ${color.g}, ${color.b}, ${alpha})` : '';
};

export default toColor;

export const toColorNoWhite = (
  color: Color,
  backup: Color,
  alpha = 1
): string => {
  if (!color) return '#ccc';
  // if it's not white
  if (color.r !== 255 || color.b !== 255 || color.g !== 255) {
    return toColor(color, alpha);
  }

  return toColorNoWhite(backup, { b: 195, g: 184, r: 171 }, alpha);
};
